import { useTranslation } from 'react-i18next'

import { ChipInput } from '@reveni-io/reveni-ui'

const TransactionTagsFilter = ({ value = [], onChange }) => {
  const { t } = useTranslation()

  return (
    <ChipInput
      label={t('Etiquetas de transacción')}
      value={value}
      onChange={onChange}
      helperText={t('Pulsa Enter o coma para añadir. Pega una lista separada por comas para añadir varios a la vez')}
    />
  )
}

export default TransactionTagsFilter
